import { DuplicateCodePinError } from "@/features/api/components/errors/DuplicateCodePinError";
import { FinancingInvalidMCFTokenProvidedError } from "@/features/api/components/errors/FinancingInvalidMCFTokenProvidedError";
import { OrganizationsArchiveUnclosedBillOrSalesError } from "@/features/api/components/errors/OrganizationsArchiveUnclosedBillOrSalesError";
import { PersonsArchiveUnclosedBillOrSalesError } from "@/features/api/components/errors/PersonsArchiveUnclosedBillOrSalesError";
import { RolesCannotDeleteOwnerRoleError } from "@/features/api/components/errors/RolesCannotDeleteOwnerRoleError";
import { RolesCannotDeleteRoleWithUsersError } from "@/features/api/components/errors/RolesCannotDeleteRoleWithUsersError";
import { RolesCannotEditOwnerRoleFloorError } from "@/features/api/components/errors/RolesCannotEditOwnerRoleFloorError";
import { SalesCannotCancelSaleWithInsufficientCashError } from "@/features/api/components/errors/SalesCannotCancelSaleWithInsufficientCashError";
import { SalesCannotCloseEmptySaleError } from "@/features/api/components/errors/SalesCannotCloseEmptySaleError";
import { SalesCannotCloseSaleFromBeninPharmacyWithoutMCFTokenError } from "@/features/api/components/errors/SalesCannotCloseSaleFromBeninPharmacyWithoutMCFTokenError";
import { SalesCannotCloseSaleWithInvalidPaymentError } from "@/features/api/components/errors/SalesCannotCloseSaleWithInvalidPaymentError";
import { SalesCannotCloseSaleWithNegativeRealMoneyError } from "@/features/api/components/errors/SalesCannotCloseSaleWithNegativeRealMoneyError";
import { SalesCannotCloseSaleWithNotEnoughPaidError } from "@/features/api/components/errors/SalesCannotCloseSaleWithNotEnoughPaidError";
import { SalesCannotCloseSaleWithoutPharmacyIdError } from "@/features/api/components/errors/SalesCannotCloseSaleWithoutPharmacyIdError";
import { SalesCannotCloseSaleWithSameContractPolicyTwiceError } from "@/features/api/components/errors/SalesCannotCloseSaleWithSameContractPolicyTwiceError";
import { SalesCannotCreateInvoiceEMECeFError } from "@/features/api/components/errors/SalesCannotCreateInvoiceEMECeFError";
import { SalesCannotCreateNewVersionOfOldSaleError } from "@/features/api/components/errors/SalesCannotCreateNewVersionOfOldSaleError";
import { SalesCannotCreateNewVersionOfSaleWithPaidBillsError } from "@/features/api/components/errors/SalesCannotCreateNewVersionOfSaleWithPaidBillsError";
import { SalesCannotDeleteBilledSaleError } from "@/features/api/components/errors/SalesCannotDeleteBilledSaleError";
import { SalesCannotDeleteNormalizedSaleError } from "@/features/api/components/errors/SalesCannotDeleteNormalizedSaleError";
import { SalesCannotEditDeletedSaleError } from "@/features/api/components/errors/SalesCannotEditDeletedSaleError";
import { SalesCannotEditOldSaleError } from "@/features/api/components/errors/SalesCannotEditOldSaleError";
import { SalesCannotRefundBilledSaleError } from "@/features/api/components/errors/SalesCannotRefundBilledSaleError";
import { SalesCannotRefundProformaSaleError } from "@/features/api/components/errors/SalesCannotRefundProformaSaleError";
import { SalesCannotRefundSaleWithoutCashRegisterError } from "@/features/api/components/errors/SalesCannotRefundSaleWithoutCashRegisterError";
import { SalesCannotRefundUnsettledSaleError } from "@/features/api/components/errors/SalesCannotRefundUnsettledSaleError";
import { SalesCannotGetInvoiceEMECeFError } from "@/features/api/components/errors/SalesCannotGetInvoiceEMECeFError";
import { SalesCannotSaleArchivedPharmacyProductError } from "@/features/api/components/errors/SalesCannotSaleArchivedPharmacyProductError";
import { SalesCannotValidateInvoiceEMECeFError } from "@/features/api/components/errors/SalesCannotValidateInvoiceEMECeFError";
import { ErrorDefinition } from "@/features/api/domain/ErrorDefinition";

import { CSVExportError } from "../components/errors/CSVExportError";
import { ForbiddenResourceError } from "../components/errors/ForbiddenResourceError";
import { DeliveriesCannotCancelDeliveryWithValidatedBillStatementError } from "../components/errors/DeliveriesCannotCancelDeliveryWithValidatedBillStatementError";
import { DeliveriesDeliveryWithThisIdentifierAlreadyExistsError } from "../components/errors/DeliveriesDeliveryWithThisIdentifierAlreadyExistsError";
import { DeliveriesMissingMultiplierCoefficientError } from "../components/errors/DeliveriesMissingMultiplierCoefficientError";
import { InventoriesCannotInventoryArchivedStockItemError } from "../components/errors/InventoriesCannotInventoryArchivedStockItemError";
import { OrderNotFoundForClose } from "../components/errors/OrderNotFoundForClose";
import { PrivateProductLabelAlreadyExistInReferentielError } from "../components/errors/PrivateProductLabelAlreadyExistInReferentielError";
import { PrivateProductLabelAlreadyExistOnAnotherPharmacyProductError } from "../components/errors/PrivateProductLabelAlreadyExistOnAnotherPharmacyProductError";
import { StocksCannotDeleteDepackagingSettingBecauseStockItemIsOnOpenInventoryError } from "../components/errors/StocksCannotDeleteDepackagingSettingBecauseStockItemIsOnOpenInventoryError";
import { SalesCannotCloseSaleWithCreditLimitExceededError } from "../components/errors/SalesCannotCloseSaleWithCreditLimitExceededError";
import { SalesCannotEditCanceledSaleError } from "../components/errors/SalesCannotEditCanceledSaleError";
import { SalesCannotEditClosedSaleError } from "../components/errors/SalesCannotEditClosedSaleError";
import { SalesCannotSalePriceCannotBeLowerThanPurchasePriceError } from "../components/errors/SalesCannotSalePriceCannotBeLowerThanPurchasePriceError";
import { UserEmailAlreadyExistsError } from "../components/errors/UserEmailAlreadyExistsError";
import { UserFirebaseUserNotFoundError } from "../components/errors/UserFirebaseUserNotFoundError";
import { UserInvalidPhoneNumberError } from "../components/errors/UserInvalidPhoneNumberError";
import { UserPhoneNumberAlreadyExistsError } from "../components/errors/UserPhoneNumberAlreadyExistsError";
import { SalesCannotEditStockItemPriceBecauseStockItemIsOnOpenInventoryError } from "../components/errors/SalesCannotEditStockItemPriceBecauseStockItemIsOnOpenInventory";

// Rejet par defaut d'un guard NestJS : n'importe quel endpoint peut le renvoyer.
export const FORBIDDEN_RESOURCE = "Forbidden resource";

export const errors: Record<string, ErrorDefinition<any>> = {
  [FORBIDDEN_RESOURCE]: {
    messageComponent: ForbiddenResourceError,
    title: "Action non autorisée",
  },

  //Financing
  "financing:invalidMCFTokenProvided": {
    messageComponent: FinancingInvalidMCFTokenProvidedError,
    modalSize: "md",
    title: "Echec authentification e-MECeF",
  },

  // Order Preparation
  "orderPreparation:orderNotFoundForClose": {
    messageComponent: OrderNotFoundForClose,
    title: "Impossible de clôturer cette préparation de commande",
  },

  // Orders
  "orders:CSVExport": {
    messageComponent: CSVExportError,
    title: "Export du CSV",
  },

  // Organizations
  "organizations:archiveUnclosedBillsOrSales": {
    messageComponent: OrganizationsArchiveUnclosedBillOrSalesError,
    title: "Archivage impossible",
  },
  // Persons
  "persons:archiveUnclosedBillsOrSales": {
    messageComponent: PersonsArchiveUnclosedBillOrSalesError,
    title: "Archivage impossible",
  },
  // Roles
  "roles:cannotDeleteRoleWithUsers": {
    messageComponent: RolesCannotDeleteRoleWithUsersError,
    modalSize: "md",
    title: "Suppression impossible",
  },
  "roles:cannotDeleteOwnerRole": {
    messageComponent: RolesCannotDeleteOwnerRoleError,
    title: "Suppression impossible",
  },
  "roles:cannotEditOwnerRoleFloor": {
    messageComponent: RolesCannotEditOwnerRoleFloorError,
    title: "Modification impossible",
  },
  "sales:cannotCloseEmptySale": {
    buttonLabel: "Reprendre",
    messageComponent: SalesCannotCloseEmptySaleError,
    modalSize: "sm",
    title: "Clôture impossible",
  },
  "sales:cannotCloseSaleFromBeninPharmacyWithoutMCFToken": {
    messageComponent: SalesCannotCloseSaleFromBeninPharmacyWithoutMCFTokenError,
    title: "Clôture impossible",
  },
  "sales:cannotCloseSaleWithInvalidPayment": {
    buttonLabel: "Reprendre les règlements",
    hasWarning: false,
    messageComponent: SalesCannotCloseSaleWithInvalidPaymentError,
    title: "Règlements à compléter",
  },
  "sales:cannotCloseSaleWithNegativeRealMoney": {
    buttonLabel: "Reprendre les règlements",
    messageComponent: SalesCannotCloseSaleWithNegativeRealMoneyError,
    modalSize: "sm",
    title: "Clôture impossible",
  },
  "sales:cannotCloseSaleWithNotEnoughPaid": {
    buttonLabel: "Reprendre les règlements",
    messageComponent: SalesCannotCloseSaleWithNotEnoughPaidError,
    modalSize: "sm",
    title: "Règlements à compléter",
  },
  "sales:cannotCloseSaleWithoutPharmacyId": {
    messageComponent: SalesCannotCloseSaleWithoutPharmacyIdError,
    title: "Clôture impossible",
  },
  "sales:cannotCancelSaleWithInsufficientCash": {
    messageComponent: SalesCannotCancelSaleWithInsufficientCashError,
    title: "Annulation impossible",
  },
  "sales:cannotCloseSaleWithSameContractPolicyTwice": {
    messageComponent: SalesCannotCloseSaleWithSameContractPolicyTwiceError,
    title: "Clôture impossible",
  },
  "sales:cannotCreateInvoiceEMECeF": {
    messageComponent: SalesCannotCreateInvoiceEMECeFError,
    title: "Clôture impossible",
  },
  // Sales
  "sales:cannotEditStockItemPriceBecauseStockItemIsOnOpenInventory": {
    messageComponent: SalesCannotEditStockItemPriceBecauseStockItemIsOnOpenInventoryError,
    title: "Modification du prix impossible",
  },
  "sales:cannotCreateNewVersionOfSaleWithPaidBills": {
    messageComponent: SalesCannotCreateNewVersionOfSaleWithPaidBillsError,
    title: "Annulation impossible",
  },

  "sales:cannotEditCanceledSale": {
    messageComponent: SalesCannotEditCanceledSaleError,
    title: "Clôture impossible",
  },

  "sales:cannotEditClosedSale": {
    messageComponent: SalesCannotEditClosedSaleError,
    title: "Clôture impossible",
  },

  "sales:cannotGetInvoiceEMECeF": {
    messageComponent: SalesCannotGetInvoiceEMECeFError,
    title: "Clôture impossible",
  },

  "sales:cannotValidateInvoiceEMECeF": {
    messageComponent: SalesCannotValidateInvoiceEMECeFError,
    title: "Clôture impossible",
  },

  "sales:cannotSaleArchivedPharmacyProduct": {
    messageComponent: SalesCannotSaleArchivedPharmacyProductError,
    title: "Clôture impossible",
  },

  "sales:salePriceCannotBeLowerThanPurchasePrice": {
    messageComponent: SalesCannotSalePriceCannotBeLowerThanPurchasePriceError,
    title: "Modification du prix impossible",
  },

  "sales:cannotCloseSaleWithCreditLimitExceeded": {
    messageComponent: SalesCannotCloseSaleWithCreditLimitExceededError,
    title: "Clôture impossible",
  },

  "sales:cannotEditOldSale": {
    messageComponent: SalesCannotEditOldSaleError,
    title: "Clôture impossible",
  },

  "sales:cannotEditDeletedSale": {
    messageComponent: SalesCannotEditDeletedSaleError,
    title: "Action impossible",
  },

  "sales:cannotDeleteBilledSale": {
    messageComponent: SalesCannotDeleteBilledSaleError,
    title: "Suppression impossible",
  },

  "sales:cannotDeleteNormalizedSale": {
    messageComponent: SalesCannotDeleteNormalizedSaleError,
    title: "Suppression impossible",
  },

  "sales:cannotRefundBilledSale": {
    messageComponent: SalesCannotRefundBilledSaleError,
    title: "Remboursement impossible",
  },

  "sales:cannotRefundProformaSale": {
    messageComponent: SalesCannotRefundProformaSaleError,
    title: "Remboursement impossible",
  },

  "sales:cannotRefundUnsettledSale": {
    messageComponent: SalesCannotRefundUnsettledSaleError,
    title: "Remboursement impossible",
  },

  "sales:cannotRefundSaleWithoutCashRegister": {
    messageComponent: SalesCannotRefundSaleWithoutCashRegisterError,
    title: "Remboursement impossible",
  },

  "sales:cannotCreateNewVersionOfOldSale": {
    messageComponent: SalesCannotCreateNewVersionOfOldSaleError,
    title: "Clôture impossible",
  },

  // Inventory
  "inventories:cannotInventoryArchivedStockItem": {
    messageComponent: InventoriesCannotInventoryArchivedStockItemError,
    title: "Mise à jour impossible",
  },
  // Users
  "users:duplicatePinCode": {
    messageComponent: DuplicateCodePinError,
    title: "Code pin déjà utilisé",
  },
  "users:phoneNumberAlreadyExists": {
    messageComponent: UserPhoneNumberAlreadyExistsError,
    title: "Numéro de téléphone déjà utilisé",
  },
  "users:emailAlreadyExists": {
    messageComponent: UserEmailAlreadyExistsError,
    title: "Adresse e-mail déjà utilisée",
  },
  "users:invalidPhoneNumber": {
    messageComponent: UserInvalidPhoneNumberError,
    title: "Numéro de téléphone invalide",
  },
  "users:firebaseUserNotFound": {
    messageComponent: UserFirebaseUserNotFoundError,
    title: "Utilisateur introuvable",
  },
  // stock
  "stocks:cannotDeleteDepackagingSettingBecauseStockItemIsOnOpenInventory": {
    messageComponent: StocksCannotDeleteDepackagingSettingBecauseStockItemIsOnOpenInventoryError,
    title: "Suppression impossible",
  },
  "stocks:privateProductLabelAlreadyExistInReferentiel": {
    messageComponent: PrivateProductLabelAlreadyExistInReferentielError,
    title: "Ce nom de produit existe déjà dans le référentiel",
  },
  "stocks:privateProductLabelAlreadyExistOnAnotherPharmacyProduct": {
    messageComponent: PrivateProductLabelAlreadyExistOnAnotherPharmacyProductError,
    title: "Ce nom de produit existe déjà dans la pharmacie",
  },

  // Deliveries
  "deliveries:cannotCancelDeliveryWithValidatedBillStatement": {
    messageComponent: DeliveriesCannotCancelDeliveryWithValidatedBillStatementError,
    title: "Abandon impossible",
  },
  "deliveries:deliveryWithThisIdentifierAlreadyExists": {
    messageComponent: DeliveriesDeliveryWithThisIdentifierAlreadyExistsError,
    title: "Création impossible",
  },
  "deliveries:missingMultiplierCoefficient": {
    messageComponent: DeliveriesMissingMultiplierCoefficientError,
    title: "Coefficient manquant",
  },
};
